import { DEFAULT_LEAD_TYPE, DEFAULT_TRAFFIC_SOURCE, DEFAULT_EVENT, WORK_STATUS } from "../config/app";

export const presetEvents = [
  { id: "awa25", name: "AWA Bangkok 25" },
  { id: "igb26", name: "iGB Affiliate Barcelona 26" },
  { id: "awdubai26", name: "Affiliate World Global Dubai 26" },
  { id: "sbc26", name: "SBC Brazil 26" },
  { id: "convconf26", name: "Conversion Conf Poland 26" },
  { id: "mac26", name: "MAC Affiliate Conference Armenia 26" },
  { id: "icon26", name: "Island Conference (i-Con) Cyprus 26" },
  { id: "ggate26", name: "G GATE Conference Georgia 26" },
  { id: "sigma_africa26", name: "SiGMA Africa 26" },
  { id: "sigma_europe26", name: "SiGMA Europe 26" },
  { id: "awasia26", name: "Affiliate World Asia 26" },
  { id: "broconf26", name: "Broconf Russia 26" },
  { id: "kinza26", name: "KINZA (CPA) 26" },
  { id: "ice26", name: "ICE (CPA) Spain 26" },
  { id: "aibc26", name: "AIBC (CPA) Dubai 26" },
  { id: "bigafrica26", name: "Big Africa Summit (CPA) 26" },
  { id: "hipther26", name: "Hipther (CPA) Czechia 26" },
  { id: "sbcmalta26", name: "SBC Malta (CPA) 26" },
  { id: "tgconf26", name: "TG Conf (CPA) Russia 26" },
  { id: "cpalife26", name: "CPA Life Russia 26" },
  { id: "awsummit26", name: "AW Summit (CPA) Hungary 26" },
  { id: "sbclisbon26", name: "SBC Summit Lisbon (CPA) 26" },
  { id: "sbctbilisi26", name: "SBC Summit Tbilisi (CPA) 26" },
  { id: "other", name: "Other" },
];

export const leadTypes = [
  "Affiliate",
  "Media Buyer",
  "MDB Team",
  "Influencer",
  "Agency",
  "Network",
  "Direct Source",
  "Payment System",
  "Service Provider",
  "Software",
  "Other",
];

export const trafficSources = [
  "TG",
  "YouTube",
  "TikTok",
  "Instagram",
  "FB",
  "VK",
  "Twitch / Kick",
  "Influence",
  "Arbitrage",
  "Other",
];

export const commissionModels = ["RevShare", "CPA", "Budget", "Other"];

// Статусы лидов
export const LEAD_STATUSES = [
  { value: "to_process", label: "To process" },
  { value: "irrelevant", label: "Irrelevant" },
  { value: "passed_to_another_team", label: "Passed to another team" },
  { value: "follow_up", label: "Follow up" },
  { value: "negotiations", label: "Negotiations" },
  { value: "fail_to_connect", label: "Fail to connect" },
  { value: "moved_to_affiliate", label: "Moved to affiliate platform" },
  { value: "hold", label: "Hold" },
];

// Приоритеты лидов
export const LEAD_PRIORITIES = [
  { value: "high", label: "High Potential" },
  { value: "medium", label: "Medium Potential" },
  { value: "low", label: "Low Potential" },
];

// Типы контактов с иконками
export const CONTACT_TYPES = [
  { key: "contact_telegram", label: "Telegram", icon: "telegram" },
  { key: "contact_whatsapp", label: "WhatsApp", icon: "whatsapp" },
  { key: "contact_wechat", label: "WeChat", icon: "wechat" },
  { key: "contact_email", label: "Email", icon: "email" },
  { key: "contact_phone", label: "Phone", icon: "phone" },
];

export const worksWithUsOptions = [
  { value: "yes", label: "Уже с нами" },
  { value: "no", label: "Пока нет" },
  { value: "unknown", label: "Не уверен" },
];

export const emptyLead = {
  id: "",
  managerTg: "",
  managerName: "",
  event: DEFAULT_EVENT,
  customEvent: "",
  name: "",
  company: "",
  contact: "",
  leadType: DEFAULT_LEAD_TYPE,
  customLeadType: "",
  trafficSource: [],  // Теперь массив
  customTraffic: "",
  worksWithUs: WORK_STATUS.UNKNOWN,
  commissionModel: "",
  customCommission: "",
  photoDataUrls: [],
  notes: "",
  notificationEnabled: false,
  notificationDate: null,
  notificationMessage: "",
  // Новые поля
  status: "to_process",
  priority: null,
  partner_id: "",
  contact_telegram: "",
  contact_whatsapp: "",
  contact_wechat: "",
  contact_email: "",
  contact_phone: "",
  createdAt: "",
  updatedAt: "",
};
